<template>
  <v-runtime-template
    :template="template"
    :class="{ disabled: hidden }"
  ></v-runtime-template>
</template>

<script>
import { AutocompleteItem } from '@mezereon/ui-components-vue'
import ExtendItem from '@/mixins/extendItem'

export default {
  mixins: [AutocompleteItem, ExtendItem]
}
</script>
